/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import {TableBasic, MediaBadge, ArrowHolder, ColumnContainer, Placeholder} from './styles';
import Utils from '../../utils/api/Utils';
import {GoChevronDown, GoChevronUp} from 'react-icons/go';

import {Tag, InputCheckbox, Media} from '..';

export default ({
  filterInput,
  titleHeader,
  pillFilter,
  dropFilter,
  selectedCheck,
  check2 = false,
  HandleOnePlayer,
  dataTableContent,
  HandleAllPlayers,
  namePills,
}: {
  check2?: boolean;
  titleHeader: string;
  filterInput: string;
  HandleOnePlayer: any;
  HandleAllPlayers: any;
  selectedCheck?: boolean;
  pillFilter?: Array<any>;
  dropFilter?: object | any;
  dataTableContent: Array<any>;
  namePills?: string;
}) => {
  const [check, useCheck] = useState(false);
  const [data, useData] = useState(dataTableContent);
  const [sort, useSort] = useState<string>('');
  const [reverse, useReverse] = useState<boolean>(false);
  const UTILS = new Utils();

  useEffect(() => {
    console.log('TableTeamPlayer - dataTableContent recibido:', dataTableContent);
    useData(() =>
      dataTableContent.filter(el => {
        if (pillFilter) {
          const pill: string = pillFilter?.filter(el => el.active === true)[0].title || '';
          if (pill === 'All' && pill) {
            return el;
          } else {
            return pill.toLowerCase()?.includes(el.player?.primaryPosition);
          }
        } else {
          return el;
        }
      }),
    );
  }, [dataTableContent, pillFilter]);

  function toggleSort(sort, params) {
    const sortOptions = [!reverse, useData, data];
    useSort(sort);
    useReverse(!reverse);
    UTILS.HandleSorted(params, sortOptions);
  }

  function toggleSortString(sort, params) {
    const sortOptions = [!reverse, useData, data];
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortStrings(params, sortOptions);
  }

  function HandleCheck() {
    useCheck(!check);
  }

  return (
    <>
      {Boolean(data.length) ? (
        <TableBasic className="table-edit" style={{marginBottom: '0'}}>
          <thead>
            <tr>
              <th onClick={() => toggleSortString('s1', ['player', 'firstName'])}>
                <ColumnContainer>
                  {Boolean(dataTableContent.length) ? (
                    <InputCheckbox
                      checked={selectedCheck}
                      onClick={() => {
                        HandleCheck();
                        HandleAllPlayers(!check);
                      }}
                    />
                  ) : (
                    <></>
                  )}
                  <span>{titleHeader}</span>
                  <ArrowHolder>
                    {sort === 's1' && reverse && <GoChevronDown size={14} />}
                    {sort === 's1' && !reverse && <GoChevronUp size={14} />}
                  </ArrowHolder>
                </ColumnContainer>
              </th>
              <th onClick={() => toggleSort('s2', ['player', '_age'])}>
                <ColumnContainer>
                  <span>AGE</span>
                  <ArrowHolder>
                    {sort === 's2' && reverse && <GoChevronDown size={14} />}
                    {sort === 's2' && !reverse && <GoChevronUp size={14} />}
                  </ArrowHolder>
                </ColumnContainer>
              </th>
              <th onClick={() => toggleSortString('s3', ['player', 'primaryPosition'])}>
                <ColumnContainer>
                  <span>POSITION</span>
                  <ArrowHolder>
                    {sort === 's3' && reverse && <GoChevronDown size={14} />}
                    {sort === 's3' && !reverse && <GoChevronUp size={14} />}
                  </ArrowHolder>
                </ColumnContainer>
              </th>
              <th onClick={() => toggleSortString('s4', ['player', 'status'])}>
                <ColumnContainer>
                  <span>STATUS</span>
                  <ArrowHolder>
                    {sort === 's4' && reverse && <GoChevronDown size={14} />}
                    {sort === 's4' && !reverse && <GoChevronUp size={14} />}
                  </ArrowHolder>
                </ColumnContainer>
              </th>
              <th onClick={() => toggleSortString('s5', ['player', 'createdAt'])}>
                <ColumnContainer>
                  <span>INVITE DATE</span>
                  <ArrowHolder>
                    {sort === 's5' && reverse && <GoChevronDown size={14} />}
                    {sort === 's5' && !reverse && <GoChevronUp size={14} />}
                  </ArrowHolder>
                </ColumnContainer>
              </th>
            </tr>
          </thead>
          <tbody className="table-player-exam" onClick={() => useSort('')}>
            {data
              .filter(el => {
                if (dropFilter) {
                  const drop: string = dropFilter?.title || '';
                  if (drop === 'Players') {
                    return el;
                  } else {
                    return drop.toLowerCase()?.includes(el.player?.primaryPosition);
                  }
                } else {
                  return el;
                }
              })

              .filter(el => {
                console.log('TableTeamPlayer - fila evaluada:', el);
                return el.player.firstName.toLowerCase().includes(filterInput.toLowerCase());
              })
              .map((item, index) => (
                <tr
                  key={index}
                  className={item?.selected && check2 ? 'special-edit-active' : item?.checked && !check2 ? 'special-edit-active' : ''}>
                  <td>
                    <MediaBadge>
                      {check2 ? (
                        <InputCheckbox onClick={() => HandleOnePlayer(item)} checked={item?.selected || false} />
                      ) : (
                        <InputCheckbox onClick={() => HandleOnePlayer(item)} checked={item?.checked || false} />
                      )}

                      <Media imgUrl={item.player.picture} name={`${item.player.firstName} ${item.player.lastName}`} max="100px" />
                    </MediaBadge>
                  </td>
                  <td>{item.player._age}</td>
                  <td>{item.player.primaryPosition}</td>
                  <td>
                    <Tag name={item.player.status || 'Active'} theme={item.player.status || 'Active'} />
                  </td>
                  <td>{(item.player.createdAt && new Date(item.player.createdAt).toLocaleDateString('en-US')) || '-'}</td>
                </tr>
              ))}
          </tbody>
        </TableBasic>
      ) : (
        <Placeholder>
          <span> ¯\_(ツ)_/¯</span> <span>You don’t have any {namePills} yet.</span>
        </Placeholder>
      )}
    </>
  );
};
